import {
  ActivityCard,
  FormLabel,
  Heading,
  Loader,
  Select,
} from "@/components";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
} from "@/components/ui";
import { yearOptions } from "@/lib/utils";
import useAudit from "./useAudit";

const Audit = () => {
  const {
    communityData,
    currentFinanceYear,
    onYearChange,
    onAccordionChange,
    openTabs,
    onExpandCollapse,
    onCreateCardClick,
    onCardClick,
    breadcrumbData,
    onBackClick,
    auditTrailCards,
    isBillingStatLoading
  } = useAudit();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title="Audit"
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
        </div>
      </div>

      {isBillingStatLoading ? <Loader /> : <>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px]">
          <h2 className="text-lg font-[600] items-start flex">
            {communityData?.name}
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-4 col-span-2 justify-end gap-[20px]">
            <div></div>
            <div></div>
            <Button onClick={onExpandCollapse}>
              {openTabs?.length ? "Collapse All" : "Expand All"}
            </Button>
            <div className="relative">
              <FormLabel>Year</FormLabel>
              <Select
                placeholder="Select Year"
                value={currentFinanceYear?.toString()}
                options={yearOptions(5)}
                onChange={onYearChange}
              />
            </div>
          </div>
        </div>

        <div className="grid grid-col-1 gap-[20px] mt-[20px]">
          <Accordion
            type="multiple"
            value={openTabs}
            onValueChange={onAccordionChange}
          >
            {/* Invoice Document Management */}
            <AccordionItem
              value="invoice"
              className="bg-white px-5 rounded-lg mb-[20px] shadow-md"
            >
              <AccordionTrigger className="cursor-pointer">
                Admin & Audit
              </AccordionTrigger>
              <AccordionContent>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] py-4">
                  {auditTrailCards?.map((data: any, index: number) => {
                    return (
                      <ActivityCard
                        key={`invoiceCard-${index}`}
                        isCreate={data.id == "create"}
                        isSummary={data.id == "summary"}
                        data={data}
                        access={!!(data as any)?.access}
                        hideCount={data.hideCount}
                        onCardClick={
                          data.id == "create" && data?.link
                            ? onCreateCardClick(data?.link)
                            : onCardClick(data?.link)
                        }
                      />
                    );
                  })}
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </>}
    </div>
  );
};

export default Audit;
